import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OauthConnectComponent } from './oauth-connect.component';

@NgModule({
  declarations: [OauthConnectComponent],
  imports: [
    CommonModule
  ],
  exports: [OauthConnectComponent]
})
export class OauthConnectModule {}
